import { configs } from '@constants/configs/configs';
import { APP_STATUSES } from '@constants/individualPortal/dashboard/dashboardModelTypes';
import { history } from '@store/appStore';

const { endpoints, externalEndpoints, states, routes } = configs;

const checkIfSubmittedAppExists = (checkPriorSubmittedApp, ssapParams) => {
    const { applicationYear, cmrHouseholdId, caseNumber } = ssapParams;
    // callback in case no submitted application exists or error
    const cb = goToSSAPStart.bind(null, { caseNumber, applicationYear });
    checkPriorSubmittedApp({ cmrHouseholdId, coverageYear: applicationYear }, cb);
};

const goToStartApp = (stateCode, ssapParams, CALHEERS_URL, householdCaseId, actions) => {
    switch (stateCode) {
        case states.CALIFORNIA: {
            AHBXRedirect(CALHEERS_URL, householdCaseId);
            break;
        }
        case states.MINNESOTA: {
            goToContactUs(states.MINNESOTA);
            break;
        }
        default: {
            checkIfSubmittedAppExists(actions.checkPriorSubmittedApp, ssapParams);
        }
    }
};

const goToResumeApp = (stateCode, ssapParams, CALHEERS_URL, householdCaseId) => {
    switch (stateCode) {
        case states.CALIFORNIA: {
            AHBXRedirect(CALHEERS_URL, householdCaseId);
            break;
        }
        case states.MINNESOTA: {
            window.open(externalEndpoints.MN_LINKS.MN_NEW_CUSTOMERS, '_blank');
            break;
        }
        default: {
            goToSSAPStart(ssapParams);
        }
    }
};

const goToContinueApp = (stateCode, ssapParams, CALHEERS_URL, householdCaseId) => {
    switch (stateCode) {
        case states.CALIFORNIA: {
            AHBXRedirect(CALHEERS_URL, householdCaseId);
            break;
        }
        case states.MINNESOTA: {
            goToContactUs(states.MINNESOTA);
            break;
        }
        default: {
            goToSSAPStart(ssapParams);
        }
    }
};

const goToGroupingScreen = ({
    tobaccoEnabled,
    hardshipEnabled,
    encryptedCaseNumber,
    applicationStatus,
    isTobaccoInformationAvailableForAllUser,
    shouldRedirectToCustomGrouping,
}) => {
    let path = routes.CUSTOM_GROUPING;

    if (tobaccoEnabled || hardshipEnabled) {
        path = `${configs.routes.TOBACCO_EXEMPT}?caseNumber=${encryptedCaseNumber}`;
        if (applicationStatus !== APP_STATUSES.ER && tobaccoEnabled && isTobaccoInformationAvailableForAllUser && shouldRedirectToCustomGrouping) {
            path = routes.CUSTOM_GROUPING;
        }
    }
    history.push(path);
};

const goToUploadDocs = (caseNumber, isRedirectToQLEMN) => {
    if(isRedirectToQLEMN) {
        history.push(`${configs.routes.QLE_DOCUMENTS_MN}?caseNumber=${caseNumber}`);
    } else {
        history.push(`${configs.routes.DMI_VERIFICATIONS}?caseNumber=${caseNumber}`);
    }
};

const goToQLEVerifications = (caseNumber, language, isRedirectToQLEMN) => {
    if(isRedirectToQLEMN) {
        history.push(`${configs.routes.QLE_DOCUMENTS_MN}?caseNumber=${caseNumber}`);
    } else {
        history.push(`${routes.VERIFICATION_DOCUMENTS}?caseNumber=${caseNumber}&language=${language}`);
    }
};

const goToViewDetails = () => {
    window.location = routes.MY_ENROLLMENT_HISTORY;
};

const goToPlanSummary = (caseNumber) => {
    history.push(routes.PLAN_SUMMARY, { caseNumber });
};

const goToApplyForCostSavings = () => {
    window.location = endpoints.IDA_LINK;
};

const goToContactUs = stateCode => {
    if (stateCode === states.MINNESOTA) {
        window.open(externalEndpoints.MN_LINKS.MN_CONTACT_US, '_blank');
    }
};

const goToContinue = stateCode => {
    if (stateCode === states.MINNESOTA) {
        window.open(externalEndpoints.MN_LINKS.MN_DOCUMENTS, '_blank');
    }
};

const goToConfirmEvent = encryptedCaseNumber => {
    window.location = endpoints.LCE_REFERRAL.processReplacements({ encryptedCaseNumber });
};

const AHBXRedirect = (CALHEERS_URL, householdCaseId) => {
    if (CALHEERS_URL) {
        window.location = externalEndpoints.CA_LINKS.CA_ACCOUNT_HOME.processReplacements({
            CALHEERS_URL,
            householdCaseId,
        });
    }
};

const goToSSAPStart = ssapParams => {
    const { caseNumber, applicationYear, fromMyApp } = ssapParams;
    // Quick fix to match what has been done in HIX-123228.
    // Need a proper refactoring, instead of passing 'fromMyApp' param, we need to replace it with history API.
    const suffix = fromMyApp ? '&fromMyApp=true' : '';
    const URL = caseNumber
        ? endpoints.START_SSAP_BY_CASE_NUMBER.processReplacements({ caseNumber })
        : endpoints.START_SSAP_BY_YEAR.processReplacements({ applicationYear });
    window.location = URL + suffix;
};

const defaultReportAChange = (ssapParams, actions) => {
    const { encryptedApplicationId, applicationStatus, caseNumber } = ssapParams;

    const cloneApp = () => {
        const url =
            (encryptedApplicationId &&
                endpoints.CLONE_APP_BY_SSAP_ID.processReplacements({ encryptedApplicationId })) ||
            null;
        url && actions.cloneApplication(url, goToSSAPStart, ssapParams);
    };

    if ([APP_STATUSES.SG, APP_STATUSES.SU].includes(applicationStatus)) {
        actions.changeAppStatus(endpoints.CHANGE_APP_STATUS.processReplacements({ caseNumber }), cloneApp);
    } else {
        cloneApp();
    }
};

const goToExceptionalEditApplication = (caseNumber, copyApplication, customGroupingParams) => {
    const url = endpoints.COPY_APP_BY_CASE_NUMBER.processReplacements({ caseNumber });
    copyApplication(url, goToGroupingScreen, customGroupingParams);
};

const goToReportAChange = (stateCode, ssapParams, CALHEERS_URL, householdCaseId, actions) => {
    switch (stateCode) {
        case states.CALIFORNIA: {
            AHBXRedirect(CALHEERS_URL, householdCaseId);
            break;
        }

        case states.MINNESOTA: {
            window.open(externalEndpoints.MN_LINKS.MN_REPORT_CHANGE, '_blank');
            break;
        }

        default: {
            defaultReportAChange(ssapParams, actions);
        }
    }
};

const goToViewAppSummary = (stateCode, ssapParams) => {
    switch (stateCode) {
        case states.CALIFORNIA:
            // Legacy - Old app summary page used for CA.
            window.location = configs.endpoints.OLD_START_SSAP_BY_CASE_NUMBER.processReplacements({
                caseNumber: ssapParams.caseNumber,
            });
            break;
        default:
            goToSSAPStart(ssapParams);
    }
};

const goToEligibilityResults = (stateCode, CALHEERS_URL, householdCaseId, encryptedCaseNumber) => {
    switch (stateCode) {
        case states.CALIFORNIA:
            window.location = externalEndpoints.CA_LINKS.CA_ELIGIBILITY.processReplacements({
                CALHEERS_URL,
                householdCaseId,
            });
            break;
        default:
            history.push(configs.routes.ELIGIBILITY_RESULTS, {
                encryptedCaseNumber,
                prevLocation: configs.routes.APPLICATIONS,
            });
    }
};

export const ctaHandlers = {
    goToStartApp,
    goToContinueApp,
    goToReportAChange,
    goToSSAPStart,
    goToApplyForCostSavings,
    goToGroupingScreen,
    goToResumeApp,
    goToContactUs,
    goToContinue,
    goToUploadDocs,
    goToViewDetails,
    goToConfirmEvent,
    goToPlanSummary,
    goToViewAppSummary,
    goToEligibilityResults,
    goToExceptionalEditApplication,
    goToQLEVerifications,
    defaultReportAChange,
};
